// import { ArrowPathIcon } from '@heroicons/react/24/outline';
import { useState, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import Table from '~/shared/components/Table';

import { useResponsiveHeaderHeight } from '../../../AllVolumesPage/AllVolumesTable/hooks/useResponsiveHeaderHeight';

import { getColumnDefs } from './columnsDefs';

import type { AutoscaleVolume } from './columnsDefs';

export const DATA_LIMIT = 50;
const sortKey = 'sort_field';

function VolumesTable({
  rowData,
  setPageOffset,
  pageOffset,
  data: data,
  loading = false,
}: {
  rowData: AutoscaleVolume[];
  setPageOffset: React.Dispatch<React.SetStateAction<string>>;
  pageOffset: string;
  data: ({ volumes: AutoscaleVolume[]; count: number } & Partial<AutoscaleVolume>) | undefined;
  loading?: boolean;
}) {
  const [_searchParams, setSearchParams] = useSearchParams();

  const [sortField] = useState<{ field: string; dir: 'desc' | 'asc' }>({
    field: 'volumeId',
    dir: 'asc',
  });

  const { headerHeight, windowWidth } = useResponsiveHeaderHeight();

  useEffect(() => {
    if (!data?.count) {
      return;
    }
    const totalPages = Math.ceil(data.count / DATA_LIMIT) || 1;
    const currentPageIdx = Math.floor((parseInt(pageOffset, 10) || 0) / DATA_LIMIT);
    if (currentPageIdx > totalPages - 1) {
      setPageOffset(`${(totalPages - 1) * DATA_LIMIT}`);
    }
  }, [data?.count, pageOffset, setPageOffset]);

  const columnDefs = useMemo(
    () =>
      getColumnDefs({
        sortField,
        windowWidth,
      }),
    [sortField, windowWidth]
  );

  const onPageChange = (page: number): void => {
    setPageOffset(`${page * DATA_LIMIT}`);
  };

  return (
    <div className="flex flex-col h-full gap-2.5 2xl:gap-3.5 [&_.ag-root-wrapper]:!border-0 [&_.ag-root-wrapper]:!rounded-none ">
      <Table
        rowData={rowData}
        columnDefs={columnDefs}
        headerHeight={headerHeight.height}
        loading={loading}
        disableClientSort
        suppressNoRowsWhileLoading
        itemsName={'volumes'}
        pagination={{
          perPage: DATA_LIMIT,
          onChange: onPageChange,
          totalPages: Math.ceil((data?.count || DATA_LIMIT) / DATA_LIMIT),
          dataCount: data?.count || 0,
          itemsName: 'volumes',
          currentPage: Math.floor((parseInt(pageOffset, 10) || 0) / DATA_LIMIT),
        }}
        onSortChange={(sort) => {
          setSearchParams(
            (params) => {
              params.set(sortKey, JSON.stringify(sort));
              return params;
            },
            { replace: true }
          );
        }}
      />
    </div>
  );
}

export default VolumesTable;
